/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pilot_How_Feedback_TitleInputs */



/**
* | output |
* | --- |
* | "Feedback based on your programme" |
*
* @param {Onboarding_Pilot_How_Feedback_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_how_feedback_title = /** @type {((inputs?: Onboarding_Pilot_How_Feedback_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_How_Feedback_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Feedback op basis van je opleiding")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un retour basé sur votre formation")
	return /** @type {LocalizedString} */ ("Feedback based on your programme")
});